<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
        &nbsp;
        <value-change-logs-detail
          :valueChangeLogs="valueChangeLogs"
          @showChangeLogs="showChangeLogs"
        ></value-change-logs-detail>
      </p>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hcCommandBaoCaoChangeLogsBuilder from "../../../services/hanhchinh/hcCaseCommand/hcCommandBaoCaoChangeLogsBuilder";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import h from "../../../services/h";
import utils from "../../../services/utils";
import ActionLogTemplate from "./action-log-template";
import constants from "../../../constants";
import ValueChangeLogsDetail from "./value-change-logs-detail";
import categoryViewService from "../../../services/categoryViewService";

export default {
  name: "hc-commands-common-update-action-log",
  components: { ValueChangeLogsDetail, ActionLogTemplate },
  props: ["actionLog", "hcCaseCommandsId"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {
      actionNameLabel: null,
      dataJson: null,
      oldHcCaseCommandsCommon: null,
      newHcCaseCommandsCommon: null,
      hcCaseCommandsList: null,
      oldHcCaseCommandsList: null,
      oldDirectiveActor: null,
      oldPerformActor: null,
      directiveActor: null,
      performActor: null,
      thucHienDepartments: null,
      oldThucHienDepartments: null,
      newDeadline: null,
      oldDeadline: null,
      valueChangeLogs: [],
      hcDocRelations: null,
      oldHcDocRelations: null,
      isPopulatedValueChangeLogs: false,
      sectorCategories: null
    };
  },

  // watch: {
  //   hcCaseCommandsId() {
  //     this.isPopulatedValueChangeLogs = false;
  //     this.valueChangeLogs = [];
  //   }
  // },

  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    this.dataJson = JSON.parse(this.actionLog.dataJson);
  },

  methods: {
    async showChangeLogs() {
      if (!this.isPopulatedValueChangeLogs) {
        this.sectorCategories = await categoryViewService
          .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.HC_COMMAND_SECTOR)
          .then(response => response.data);
        this.populateValueChangeLogs();
        await this.populateBaoCaoChangeLogs();
        this.isPopulatedValueChangeLogs = true;
      }
    },

    formatDate(value) {
      return hanhChinhUtils.formatDate(value);
    },

    getDisplayProperty(property) {
      switch (property) {
        case "meeting":
          return "Cuộc họp";
        case "sector":
          return "Lĩnh vực";
        case "commandsDate":
          return "Ngày chỉ đạo";
        case "conclusion":
          return "Nội dung kết luận";
        case "directiveId":
          return "Lãnh đạo chỉ đạo";
        case "performId":
          return "Lãnh đạo phụ trách";
        case "deadline":
          return "Thời hạn hoàn thành";
        case "directionContent":
          return "Ý kiến chỉ đạo";
        case "chuTriDepts":
          return "Đơn vị chủ trì";
        case "phoiHopDepts":
          return "Đơn vị phối hợp";
        case "hcDocRelations":
          return "Văn bản liên quan";
        default:
          return "-";
      }
    },

    populateBaoCaoChangeLogs() {
      return this.dataJson.hcCommandsBaoCaoActionLog
        ? hcCommandBaoCaoChangeLogsBuilder
            .newInstance()
            .build(this.dataJson.hcCommandsBaoCaoActionLog)
            .then(({ valueChangeLogs }) =>
              this.valueChangeLogs.push(...valueChangeLogs)
            )
        : Promise.resolve();
    },

    populateValueChangeLogs() {
      this.oldHcCaseCommandsCommon = this.dataJson.oldHcCaseCommandsCommon;
      this.newHcCaseCommandsCommon = this.dataJson.newHcCaseCommandsCommon;
      this.hcCaseCommandsList = this.dataJson.hcCaseCommandsList;
      this.oldHcCaseCommandsList = this.dataJson.oldHcCaseCommandsList;
      this.oldDirectiveActor = this.dataJson.oldDirectiveActor;
      this.oldPerformActor = this.dataJson.oldPerformActor;
      this.directiveActor = this.dataJson.directiveActor;
      this.performActor = this.dataJson.performActor;
      this.thucHienDepartments = this.dataJson.thucHienDepartments;
      this.oldThucHienDepartments = this.dataJson.oldThucHienDepartments;
      this.newDeadline = this.dataJson.newDeadline;
      this.oldDeadline = this.dataJson.oldDeadline;
      this.hcDocRelations = this.dataJson.hcDocRelations || [];
      this.oldHcDocRelations = this.dataJson.oldHcDocRelations || [];

      h.each(
        [
          "meeting",
          "sector",
          "commandsDate",
          "conclusion",
          "directiveId",
          "performId",
          "deadline",
          "directionContent",
          "chuTriDepts",
          "phoiHopDepts",
          "hcDocRelations"
        ],
        property => {
          let oldValue;
          let newValue;
          switch (property) {
            case "deadline":
              if (this.oldDeadline !== this.newDeadline) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: this.formatDate(this.oldDeadline),
                  newValue: this.formatDate(this.newDeadline)
                });
              }
              break;
            case "directiveId":
            case "performId":
              this.populateValueChangeLogsForActor(property);
              break;
            case "chuTriDepts":
            case "phoiHopDepts":
              this.populateValueChangeLogsForThucHienDepts(property);
              break;
            case "hcDocRelations":
              this.populateValueChangeLogsForHcDocRelations(property);
              break;
            case "sector":
              oldValue = this.oldHcCaseCommandsCommon[property];
              newValue = this.newHcCaseCommandsCommon[property];
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: hanhChinhUtils.getHcCommandSectorName(
                    oldValue,
                    this.sectorCategories
                  ),
                  newValue: hanhChinhUtils.getHcCommandSectorName(
                    newValue,
                    this.sectorCategories
                  )
                });
              }
              break;
            case "commandsDate":
              oldValue = this.formatDate(
                this.oldHcCaseCommandsCommon[property]
              );
              newValue = this.formatDate(
                this.newHcCaseCommandsCommon[property]
              );
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: oldValue,
                  newValue: newValue
                });
              }
              break;
            default:
              oldValue = this.oldHcCaseCommandsCommon[property];
              newValue = this.newHcCaseCommandsCommon[property];
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: oldValue,
                  newValue: newValue
                });
              }
              break;
          }
        }
      );
    },

    populateValueChangeLogsForThucHienDepts(property) {
      let processType;
      switch (property) {
        case "chuTriDepts":
          processType = constants.HC_CASE_COMMANDS.PROCESS_TYPE.CHU_TRI;
          break;
        case "phoiHopDepts":
          processType = constants.HC_CASE_COMMANDS.PROCESS_TYPE.PHOI_HOP;
          break;
      }

      let oldDepartments = h.findAll(this.oldThucHienDepartments, dept =>
        h.exists(
          this.oldHcCaseCommandsList,
          hcCaseCommands =>
            hcCaseCommands.deptId === dept.id &&
            hcCaseCommands.processType === processType
        )
      );

      let departments = h.findAll(this.thucHienDepartments, dept =>
        h.exists(
          this.hcCaseCommandsList,
          hcCaseCommands =>
            hcCaseCommands.deptId === dept.id &&
            hcCaseCommands.processType === processType
        )
      );

      let oldValue = (h.collect(oldDepartments, dept => dept.deptName) || [])
        .join("\n")
        .trim();

      let newValue = (h.collect(departments, dept => dept.deptName) || [])
        .join("\n")
        .trim();

      if (oldValue !== newValue) {
        this.valueChangeLogs.push({
          property: property,
          propertyLabel: this.getDisplayProperty(property),
          oldValue: oldValue,
          newValue: newValue
        });
      }
    },

    populateValueChangeLogsForActor(property) {
      let oldId;
      let newId;
      let oldActor;
      let newActor;
      switch (property) {
        case "directiveId":
          oldId = this.oldDirectiveActor ? this.oldDirectiveActor.id : null;
          newId = this.directiveActor ? this.directiveActor.id : null;
          oldActor = this.oldDirectiveActor;
          newActor = this.directiveActor;
          break;
        case "performId":
          oldId = this.oldPerformActor ? this.oldPerformActor.id : null;
          newId = this.performActor ? this.performActor.id : null;
          oldActor = this.oldPerformActor;
          newActor = this.performActor;
          break;
      }
      if (oldId !== newId) {
        this.valueChangeLogs.push({
          property: property,
          propertyLabel: this.getDisplayProperty(property),
          oldValue: utils.buildUserDeptRoleViewLabel(oldActor),
          newValue: utils.buildUserDeptRoleViewLabel(newActor)
        });
      }
    },

    populateValueChangeLogsForHcDocRelations(property) {
      hanhChinhUtils.populateValueChangeLogsForHcDocRelations(
        property,
        this.oldHcDocRelations,
        this.hcDocRelations,
        this.valueChangeLogs,
        this.getDisplayProperty(property)
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-common-update-action-log.vue